@if (!!allCount()) {
  {{ 'Backup' | translate }}
  <a
    *ixRequiresRoles="[Role.CloudSyncWrite]"
    class="backup-action"
    ixTest="cloud"
    (click)="addCloudSyncTask.emit()"
  >
    {{ 'to cloud' | translate }}
  </a>
  {{ 'or' | translate }}
  <a
    *ixRequiresRoles="[Role.ReplicationTaskWrite, Role.ReplicationTaskWritePull]"
    class="backup-action"
    ixTest="another-TrueNAS"
    (click)="addReplicationTask.emit()"
  >
    {{ 'to another TrueNAS' | translate }}
  </a>
} @else {
  <ng-container *ixRequiresRoles="[Role.FullAdmin]"></ng-container>
  {{ 'Backup to Cloud or another TrueNAS via links below' | translate }}
}

